import { palette } from '../../../utils/designTokens';

export function tint(color, percent) {
  return `color-mix(in srgb, ${color} ${percent}%, transparent)`;
}

export function statusStyle(status) {
  const color = status === 'resolved' ? palette.status.success : palette.status.warning;
  return {
    color,
    backgroundColor: tint(color, 12),
    borderColor: tint(color, 35),
  };
}

export function feedbackStyle(active, color) {
  if (!active) {
    return {
      color: palette.text.primary,
      borderColor: palette.borders.subtle,
      backgroundColor: 'transparent',
    };
  }
  return {
    color,
    backgroundColor: tint(color, 12),
    borderColor: tint(color, 45),
  };
}

export function feedbackIconStyle(active, color) {
  return {
    ...feedbackStyle(active, color),
    boxShadow: active ? `0 0 0 1px ${tint(color, 25)}, 0 8px 22px ${tint(color, 16)}` : 'none',
  };
}

export function errorBannerStyle() {
  return {
    color: palette.status.danger,
    backgroundColor: tint(palette.status.danger, 10),
    borderColor: tint(palette.status.danger, 40),
  };
}

export function infoBannerStyle() {
  return {
    color: palette.status.info,
    backgroundColor: tint(palette.status.info, 10),
    borderColor: tint(palette.status.info, 40),
  };
}

export function shortId(value) {
  return value ? String(value).slice(0, 10) : 'unknown';
}
